import { Passage, Room } from '..';
import { Direction } from '../../../parse';
import { EntitySpec } from '../../game';
import { WideLedge } from '../WideLedge';
import { Safe, SafeHole } from '../../items';

export class DustyRoom extends Room {
    static spec(): EntitySpec<DustyRoom> {
        return {
            ref: 'dusty-room',
            constructor: DustyRoom,
            initial: {
                contents: [SafeHole.spec().ref, Safe.spec().ref],
                hasBeenVisited: false,
                hasBeenDescribed: false,
            },
            nouns: [],
            adjectives: [],
        };
    }

    ref() {
        return DustyRoom.spec().ref;
    }

    name(): string {
        return 'Dusty Room';
    }

    description(): string {
        return (
            'You are in a dusty old room which is virtually featureless, ' +
            'except for an exit on the north side.'
        );
    }

    isNaturallyLit(): boolean {
        return false;
    }

    passages(): Passage[] {
        return [
            new Passage({
                via: Direction.North,
                to: WideLedge.spec().ref,
            }),
        ];
    }
}
